import './FixedTitleMultipleSelect.scss';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import blackDownArrowTriPng from '../../assets/images/common/black-down-arrow-tri.png';
import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';

class SpeedPlugin extends ScrollbarPlugin {
  static pluginName = 'customSpeed';

  static defaultOptions = {
    speed: 1,
  };

  transformDelta(delta) {
    return {
      x: delta.x * this.options.speed,
      y: delta.y * this.options.speed,
    };
  }
}

const instanceManager = new Set();

const FixedTitleMultipleSelect = (props) => {
  const { options, title, selectFun } = props;

  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [showContent, setShowContent] = useState(false);

  const handleSlectedClick = () => {
    if (showContent) {
      instanceManager.forEach(({ closeFn }) => closeFn());
    } else {
      setShowContent(!showContent);
    }
  };

  const handleScrollDown = () => {
    Scrollbar.get(contentRef.current).scrollTo(
      0,
      Scrollbar.get(contentRef.current).scrollTop + 24,
      400,
    );
  };

  const handleItemClick = useCallback(
    (itemValue) => {
      let newSelectedItems;
      if (selectedItems.includes(itemValue)) {
        newSelectedItems = selectedItems.filter((item) => item !== itemValue);
      } else {
        newSelectedItems = [...selectedItems, itemValue];
      }

      setSelectedItems(newSelectedItems);
      selectFun(newSelectedItems);
    },
    [selectedItems],
  );

  useEffect(() => {
    const container = contentRef.current.parentElement;

    const handleTransitionEnd = () => {
      if (contentRef.current?.children?.length) {
        if (Scrollbar.has(contentRef.current)) {
          Scrollbar.get(contentRef.current).scrollTop = 0;

          if (contentRef.current.clientHeight) {
            Scrollbar.get(contentRef.current).update();
          }
        }

        if (!Scrollbar.has(contentRef.current)) {
          Scrollbar.use(SpeedPlugin);

          Scrollbar.init(contentRef.current, {
            damping: 0.08,
            thumbMinSize: 30,
            renderByPixels: true,
            alwaysShowTracks: true,
            continuousScrolling: false,
            plugins: {
              customSpeed: {
                speed: 1,
              },
            },
          });
        }
      }
    };

    const handleClickOutside = (event) => {
      const isInsideAny = Array.from(instanceManager).some(({ wrapper }) =>
        wrapper.current?.contains(event.target),
      );

      if (!isInsideAny) {
        instanceManager.forEach(({ closeFn }) => closeFn());
      }
    };

    const closeShowContent = () => {
      setShowContent(false);
    };

    const instance = { wrapper: wrapperRef, closeFn: closeShowContent };
    instanceManager.add(instance);

    container.addEventListener('transitionend', handleTransitionEnd);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      if (Scrollbar.has(contentRef.current)) {
        Scrollbar.destroy(contentRef.current);
      }
      container.removeEventListener('transitionend', handleTransitionEnd);
      document.removeEventListener('mousedown', handleClickOutside);
      instanceManager.delete(instance);
    };
  }, []);

  return (
    <div className={`fixedTitleMultipleSelect`} ref={wrapperRef}>
      <div
        className={`title ${showContent ? 'open' : ''}`}
        onClick={(e) => {
          handleSlectedClick();
        }}
      >
        {title}
      </div>
      <div className={`content ${showContent ? 'open' : ''}`} ref={contentRef}>
        {options?.map((item, index) => (item.label ?? '') !== '' && 
        (
          <div
            key={item.value}
            className={`item ${selectedItems.includes(item.value) ? 'active' : ''}`}
            onClick={() => handleItemClick(item.value)}
          >
            {item.label}
          </div>
        ))}
      </div>
      <div
        onClick={(e) => {
          handleScrollDown();
        }}
        className={`down-btn  ${showContent ? 'open' : ''}`}
      >
        <img src={blackDownArrowTriPng} />
      </div>
    </div>
  );
};

export default FixedTitleMultipleSelect;
